export class ExpensesPeriod {
    month: number;
    year: number;
}
